
import LandingBanner from '../components/Landing/LandingBanner.vue';
import LandingImageLink from '../components/Landing/LandingImageLink.vue';
export default {
  components: { LandingBanner, LandingImageLink },
};
